<template>
  <v-data-table
    :headers="headers"
    :items="perguntasRespondidas"
    class="elevation-1"
    hide-default-footer
    disable-pagination
    item-key="perguntaMunicipioId"
  >
    <template v-slot:item="props">
      <tr class="evidenciar">
        <td>{{ props.item.pergunta.tema.nome }}</td>
        <td>{{ props.item.pergunta.numero }}</td>
        <td>
          <div>
            <div>{{ props.item.pergunta.texto }}</div>
          </div>
        </td>
        <td>{{ props.item.pergunta.pontos }}</td>
        <td width="300px">
          <v-file-input
            v-if="
              isFullAdmin ||
              (groupsConfig.enviarRespondidas && config.enviarRespondidas)
            "
            multiple
            label="Selecione Arquivos de Evidência"
            v-model="props.item.arquivos"
          >
          </v-file-input>
        </td>
        <td>
          <v-btn
            v-if="
              isFullAdmin ||
              (groupsConfig.enviarRespondidas && config.enviarRespondidas)
            "
            outlined
            color="primary"
            class="ml-3"
            @click="sendEvidences(props.item)"
          >
            <span>Enviar</span>
          </v-btn>
        </td>
        <td
          v-if="
            props.item.pergunta.evidencia && props.item.evidenciada === false
          "
        >
          <app-modal-show-evidence
            :evidence="props.item.pergunta.evidencia"
            :color="'primary'"
            v-if="props.item.pergunta.evidencia.length > 0"
          >
          </app-modal-show-evidence>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { sortArrayAsc } from "../../../../helpers/utils";

export default {
  components: {
    AppModalShowEvidence,
  },
  data() {
    return {
      headers: [
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ],
      municipioId: this.$route.params.id,
      perguntasRespondidas: [],
      allPerguntas: [],
      user: JSON.parse(localStorage.getItem("user")),

      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        if (val.temas.length)
          this.perguntasRespondidas = this.allPerguntas.filter((pa) =>
            val.temas.some((te) => te.nome === pa.pergunta.tema.nome)
          );
        else this.perguntasRespondidas = this.allPerguntas;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    loadAnsweredQuestions() {
      this.setLoading(true);
      cityQuestionAPI
        .getRespondidas(this.municipioId)
        .then((resp) => {
          this.perguntasRespondidas = resp.data.sort((a, b) => {
            return (
              sortArrayAsc(a.pergunta.temaId, b.pergunta.temaId) ||
              sortArrayAsc(a.pergunta.numero, b.pergunta.numero)
            );
          });

          if (!this.user.grupo.verTodosEixos) {
            this.perguntasRespondidas = this.perguntasRespondidas.filter(
              (item) =>
                this.user.permissoes.some(
                  (per) =>
                    per.eixoId === item.pergunta.tema.eixoId &&
                    per.municipioId === item.municipioId
                )
            );
          }

          this.allPerguntas = this.perguntasRespondidas;

          if (this.filter.temas.length > 0) {
            this.perguntasRespondidas = this.allPerguntas.filter((pa) =>
              this.filter.temas.some((te) => te.nome === pa.pergunta.tema.nome)
            );
          }

          this.setLoading(false);
        })
        .catch((er) => {
          console.log("Erro ao listas perguntas respondidas: ", er);
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    sendEvidences(question) {
      if (question.arquivos.length === 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
      } else {
        this.setLoading(true);

        let formData = new FormData();

        for (let i = 0; i < question.arquivos.length; i++) {
          formData.append("arquivos", question.arquivos[i]);
        }

        formData.append("perguntaMunicipioId", question.perguntaMunicipioId);

        cityQuestionAPI
          .salvarEvidencias(formData)
          .then((resp) => {
            this.$notification.success("Evidência salva com sucesso");
            this.loadAnsweredQuestions();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar evidência");
          });
      }
    },
  },

  mounted() {
    this.loadAnsweredQuestions();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isAnalista",
      "isFullAdmin",
    ]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
